module.exports = __webpack_public_path__ + "img/customer.c29455c7.png";